import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  id: "main-content-port",
  class: "h100 link",
  style: {}
}
const _hoisted_4 = {
  class: "",
  id: "RoomsContainer"
}
const _hoisted_5 = {
  class: "kakugo w100",
  style: {"height":"120px","top":"0","z-index":"10"},
  id: "RoomsContainer"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  class: "kakugo posFi shadowContent messageHeader with_white_bg",
  style: {"top":"0","z-index":"10","width":"calc(100% - 80px)"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fl fw400" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs18",
    style: {"line-height":"68px","margin-left":"40px"}
  }, "進捗を確認")
], -1)
const _hoisted_9 = {
  key: 0,
  class: "fl ml20",
  style: {"line-height":"68px"}
}
const _hoisted_10 = {
  class: "fr",
  style: {"line-height":"68px","margin-right":"20px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "w100",
  style: {"margin-top":"70px"}
}
const _hoisted_13 = { class: "w100 roomTableContent" }
const _hoisted_14 = {
  key: 0,
  class: "thStatus"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "thName" }, null, -1)
const _hoisted_16 = {
  key: 1,
  class: "thButtons"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", {
  class: "w100",
  style: {"background":"#777"}
}, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "whiteColor",
    style: {"height":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      style: {"margin-left":"10px"},
      class: "fs11"
    }, "出席者 確認状況")
  ])
], -1)
const _hoisted_18 = {
  class: "w100",
  style: {"border-bottom":"1px solid #e9ecf1"}
}
const _hoisted_19 = {
  colspan: "3",
  class: "fs12 fw600 pad5",
  style: {"height":"20px"}
}
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"fl\" style=\"width:420px;\"> </div><div class=\"fl\" style=\"width:500px;\"><div class=\"fl centered mt7\" style=\"\">送信済み</div><div class=\"fl centered\" style=\"margin-left:74px;\"> メール <br>開封済み </div><div class=\"fl centered mt7\" style=\"margin-left:76px;\">入室済み</div><div class=\"fl centered\" style=\"margin-left:60px;\"> 調整カレンダー <br>共有済み </div></div>", 2)
const _hoisted_22 = ["src"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-top":"3px","margin-left":"-3px"} }, " 履歴", -1)
const _hoisted_24 = {
  class: "w100 ofs",
  style: {"height":"calc(100vh - 220px)"}
}
const _hoisted_25 = { class: "w100" }
const _hoisted_26 = {
  key: 1,
  class: "w100",
  style: {"margin-top":"70px"}
}
const _hoisted_27 = { class: "w100" }
const _hoisted_28 = {
  key: 0,
  class: "thStatus"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "thName" }, null, -1)
const _hoisted_30 = {
  key: 1,
  class: "thButtons"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "w100",
  style: {"background":"#777"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "whiteColor",
    style: {"height":"20px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      style: {"margin-left":"10px"},
      class: "fs11"
    }, " ")
  ])
], -1)
const _hoisted_32 = {
  class: "w100 with_white_bg",
  style: {"height":"50px"}
}
const _hoisted_33 = {
  class: "w100",
  style: {}
}
const _hoisted_34 = {
  class: "w100",
  style: {"height":"50px","border-bottom":"1px solid #ddd","min-width":"1200px"}
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = {
  key: 1,
  class: "w100"
}
const _hoisted_41 = {
  key: 0,
  class: "w100"
}
const _hoisted_42 = { key: 2 }
const _hoisted_43 = {
  key: 0,
  class: "w100",
  style: {"height":"calc(100vh - 280px)"}
}
const _hoisted_44 = {
  key: 0,
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_45 = {
  class: /*#__PURE__*/_normalizeClass(`fs12 fr pointer pad8`),
  style: {"width":"230px"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: `voted_with_not_voted_`,
  class: "fs12 pointer"
}, " 投票済みの調整ページも表示", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "調整ページが見つかりませんでした。", -1)
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 3,
  class: "w100 roomTableContentWrapper",
  id: "roomTableContentWrapper"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_57 = {
  key: 1,
  class: "w100 roomTableContent"
}
const _hoisted_58 = {
  key: 1,
  class: "w100"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "調整ページが見つかりませんでした。", -1)
const _hoisted_63 = ["src"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_65 = { key: 2 }
const _hoisted_66 = {
  key: 2,
  class: "w100 ofs",
  id: "downloadableContent",
  style: {"height":"calc(100vh - 220px)"}
}
const _hoisted_67 = { class: "pad40" }
const _hoisted_68 = {
  key: 0,
  class: "w100 pad15"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fw600 w30 fl pad20" }, "ダウンロード一覧", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_71 = { class: "w100 ml20" }
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"w100\"><p class=\"fl fs12 fw600 ml15\" style=\"width:400px;\">ファイル名</p><p class=\"fl fs12 fw600\" style=\"width:120px;\">ファイルサイズ</p><p class=\"fl fs12 fw600\" style=\"width:180px;\">作成日時</p><p class=\"fl fs12 fw600\" style=\"width:150px;\">ステータス</p><div class=\"fl\" style=\"width:280px;\"> </div><div class=\"clear\"></div></div>", 1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "w100 ml20" }, [
  /*#__PURE__*/_createTextVNode(" この公開ページに紐づく調整ページをダウンロードします。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_76 = { key: 3 }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "調整ページが見つかりませんでした。", -1)
const _hoisted_81 = ["src"]
const _hoisted_82 = {
  key: 1,
  class: "w100 roomTableContent"
}
const _hoisted_83 = { key: 3 }
const _hoisted_84 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_RoomCell = _resolveComponent("RoomCell")!
  const _component_UserStatusCell = _resolveComponent("UserStatusCell")!
  const _component_StatsContent = _resolveComponent("StatsContent")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_FixTabRoomCellsContent = _resolveComponent("FixTabRoomCellsContent")!
  const _component_SuggestedRooms = _resolveComponent("SuggestedRooms")!
  const _component_DownloadableFileCell = _resolveComponent("DownloadableFileCell")!
  const _component_DownloadConditionsContent = _resolveComponent("DownloadConditionsContent")!
  const _component_ParentRoomGroupCell = _resolveComponent("ParentRoomGroupCell")!
  const _component_ModalRoomMembersLink = _resolveComponent("ModalRoomMembersLink")!
  const _component_PublicLinkModal = _resolveComponent("PublicLinkModal")!
  const _component_RoomHistoryDetailModal = _resolveComponent("RoomHistoryDetailModal")!
  const _component_ModalCancelAppointment = _resolveComponent("ModalCancelAppointment")!
  const _component_CreateFromDraftModal = _resolveComponent("CreateFromDraftModal")!
  const _component_CreateFeedbackModal = _resolveComponent("CreateFeedbackModal")!
  const _component_AnsweredFormModal = _resolveComponent("AnsweredFormModal")!
  const _component_PrivateMemoModal = _resolveComponent("PrivateMemoModal")!
  const _component_InputFileNameModal = _resolveComponent("InputFileNameModal")!
  const _component_ShareAuthModal = _resolveComponent("ShareAuthModal")!
  const _component_ChukaiMenuModal = _resolveComponent("ChukaiMenuModal")!
  const _component_RemindModal = _resolveComponent("RemindModal")!
  const _component_PargProgressPanel = _resolveComponent("PargProgressPanel")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("section", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_5, [
            (_ctx.room)
              ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                  _createElementVNode("section", _hoisted_7, [
                    _hoisted_8,
                    (_ctx.room.room_type == `parent_room` && _ctx.room.public_room_id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("label", {
                            class: _normalizeClass(`fs11 label dblueBg pointer`),
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goSummaryFromParent && _ctx.goSummaryFromParent(...args)))
                          }, " 公開ページへ移動 ")
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", {
                        class: "pointer fs14 fw600 circle_button skyblueBg",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goProgresses && _ctx.goProgresses(...args)))
                      }, "全体の進捗管理")
                    ]),
                    _hoisted_11
                  ]),
                  (_ctx.room.room_type == `parent_room` && !_ctx.isPubPage)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        _createElementVNode("table", _hoisted_13, [
                          _createElementVNode("tr", null, [
                            (!_ctx.isSP)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_14))
                              : _createCommentVNode("", true),
                            _hoisted_15,
                            (!_ctx.isSP)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_16))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_RoomCell, {
                            room: _ctx.room,
                            onGoRoom: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goRoomFromTr(_ctx.room))),
                            onShowMembersLinks: _ctx.showMembersLinks,
                            onCreateFeedback: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createFeedbackRoom(_ctx.room))),
                            onCancelAppo: _ctx.cancelAppo,
                            onChangeActive: _ctx.changeActive,
                            onSearchByMember: _ctx.searchByMember,
                            onSearchByMag: _ctx.searchByMag,
                            canDelete: false
                          }, null, 8, ["room", "onShowMembersLinks", "onCancelAppo", "onChangeActive", "onSearchByMember", "onSearchByMag"]),
                          _hoisted_17,
                          _createElementVNode("tr", _hoisted_18, [
                            _createElementVNode("td", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("label", {
                                class: _normalizeClass(`fw400 fr centered fs12 blueAround pointer ml9 mt3`),
                                style: {"width":"80px","padding":"4px 10px"},
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showHistory(_ctx.room)))
                              }, [
                                _createElementVNode("img", {
                                  src: _ctx.$getAssetImageUrl(`/assets/icons/menu_icon01.png`),
                                  width: "13",
                                  height: "13",
                                  style: {"margin-top":"-2px"}
                                }, null, 8, _hoisted_22),
                                _hoisted_23
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("table", _hoisted_25, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.room.attendees, (mem, memindex) => {
                              return (_openBlock(), _createBlock(_component_UserStatusCell, {
                                key: `${mem.id}${_ctx.room.id}${memindex}`,
                                room: _ctx.room,
                                mem: mem,
                                memindex: memindex,
                                showIcon: true,
                                onCreateFeedback: _ctx.createFeedback,
                                onClickFormMember: _ctx.clickFormMember,
                                onClickRemind: _ctx.clickRemind
                              }, null, 8, ["room", "mem", "memindex", "onCreateFeedback", "onClickFormMember", "onClickRemind"]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("section", _hoisted_26, [
                        _createElementVNode("table", _hoisted_27, [
                          _createElementVNode("tr", null, [
                            (!_ctx.isSP)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_28))
                              : _createCommentVNode("", true),
                            _hoisted_29,
                            (!_ctx.isSP)
                              ? (_openBlock(), _createElementBlock("th", _hoisted_30))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_RoomCell, {
                            room: _ctx.room,
                            onGoRoom: _ctx.goRoomFromTr,
                            onShowPublicLink: _ctx.showPublicLink,
                            onCancelAppo: _ctx.cancelAppo,
                            onCreateFeedback: _ctx.createFeedbackRoom,
                            onSearchByMember: _ctx.searchByMember,
                            onSearchByMag: _ctx.searchByMag,
                            onEditPrivateMemo: _ctx.editPrivateMemo,
                            onEditOpenScheduleMemo: _ctx.editOpenScheduleMemo,
                            onShowShareAuthModal: _ctx.showShareAuthModal,
                            onClickSummary: _ctx.clickSummary
                          }, null, 8, ["room", "onGoRoom", "onShowPublicLink", "onCancelAppo", "onCreateFeedback", "onSearchByMember", "onSearchByMag", "onEditPrivateMemo", "onEditOpenScheduleMemo", "onShowShareAuthModal", "onClickSummary"])
                        ]),
                        _hoisted_31,
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryAll pointer centered fl ${
                                                    _ctx.selectedTab == 'pv' ? 'selected fw600' : ''
                                                }`),
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectTab(`pv`)))
                              }, " 閲覧数 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'fixed' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"180px"},
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTab(`fixed`)))
                              }, " 今後の確定 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'voted' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"180px"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTab('voted')))
                              }, " 投票中 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'parg' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"180px"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTab('parg')))
                              }, " ステップ調整 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'notVoted' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"180px"},
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectTab('notVoted')))
                              }, " 調整中 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'closed' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"180px"},
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectTab('closed')))
                              }, " 終了 ", 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`roomsCategoryTab categoryFixed pointer centered fl ${
                                                    _ctx.selectedTab == 'download' ? 'selected fw600' : ''
                                                }`),
                                style: {"width":"140px"},
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectTab('download')))
                              }, " ダウンロード ", 2)
                            ])
                          ])
                        ]),
                        _hoisted_35,
                        (_ctx.selectedTab == `parg`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${
                                                _ctx.selectedSmallCategoryTabName == `active_in_progress` ? `fw600 selected` : ``
                                            }`),
                                  style: {"width":"120px"},
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectPargSmallCategory(`active_in_progress`)))
                                }, " 調整中 ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${
                                                _ctx.selectedSmallCategoryTabName == `fixed` ? `fw600 selected` : ``
                                            }`),
                                  style: {"width":"140px"},
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectPargSmallCategory(`fixed`)))
                                }, " 今後の確定 ", 2),
                                _createElementVNode("div", {
                                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${
                                                _ctx.selectedSmallCategoryTabName == `closed` ? `fw600 selected` : ``
                                            }`),
                                  style: {"width":"120px"},
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectPargSmallCategory(`closed`)))
                                }, " 終了 ", 2),
                                _hoisted_38
                              ]),
                              _hoisted_39
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.selectedTab == `pv`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              (_ctx.room)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createVNode(_component_StatsContent, { room: _ctx.room }, null, 8, ["room"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.currentTabRooms)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              ([`fixed`, `closed`, `notVoted`].includes(_ctx.selectedTab))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    (_ctx.selectedTab == `notVoted`)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                          _createElementVNode("div", _hoisted_45, [
                                            _createVNode(_component_CheckboxTag, {
                                              value: ``,
                                              name: `send_mail_fix_member`,
                                              checked: _ctx.showVotedAndNotVoted,
                                              prefix: `voted_with_not_voted`,
                                              onClickCheckbox: _ctx.clickNotVotedWithVoted,
                                              class: "ml1"
                                            }, null, 8, ["checked", "onClickCheckbox"]),
                                            _hoisted_46
                                          ]),
                                          _hoisted_47
                                        ]))
                                      : _createCommentVNode("", true),
                                    _hoisted_48,
                                    (!_ctx.currentTabRooms)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                          _createVNode(_component_RoomsLoader)
                                        ]))
                                      : (_ctx.currentTabRooms.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                            _createElementVNode("div", _hoisted_51, [
                                              _hoisted_52,
                                              _createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                                width: "40",
                                                height: "40"
                                              }, null, 8, _hoisted_53)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("section", _hoisted_54, [
                                            (_ctx.selectedTab == 'fixed')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                  _createVNode(_component_FixTabRoomCellsContent, {
                                                    currentTabRooms: _ctx.currentTabRooms,
                                                    showRoomModal: _ctx.showRoomModal,
                                                    onGoRoom: _ctx.goRoomFromTr,
                                                    onClickSummary: _ctx.clickSummary,
                                                    onShowMembersLinks: _ctx.showMembersLinks,
                                                    onShowPublicLink: _ctx.showPublicLink,
                                                    onCancelVoted: _ctx.cancelVoted,
                                                    onCancelAppo: _ctx.cancelAppo,
                                                    onCreateFeedback: _ctx.createFeedback,
                                                    onChangeActive: _ctx.changeActive,
                                                    onSearchByMember: _ctx.searchByMember,
                                                    onSearchByMag: _ctx.searchByMag,
                                                    onClickFormMember: _ctx.clickFormMember,
                                                    onEditPrivateMemo: _ctx.editPrivateMemo,
                                                    onEditOpenScheduleMemo: _ctx.editOpenScheduleMemo
                                                  }, null, 8, ["currentTabRooms", "showRoomModal", "onGoRoom", "onClickSummary", "onShowMembersLinks", "onShowPublicLink", "onCancelVoted", "onCancelAppo", "onCreateFeedback", "onChangeActive", "onSearchByMember", "onSearchByMag", "onClickFormMember", "onEditPrivateMemo", "onEditOpenScheduleMemo"]),
                                                  _hoisted_56
                                                ]))
                                              : (_openBlock(), _createElementBlock("table", _hoisted_57, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTabRooms, (room) => {
                                                    return (_openBlock(), _createBlock(_component_RoomCell, {
                                                      key: `${room.id}-${room.updatedAtText}-${room.unread_num}-${room.starred}${room.is_expired}`,
                                                      room: room,
                                                      canDelete: room.isParent && !room.is_expired,
                                                      showRoomModal: _ctx.showRoomModal,
                                                      onGoRoom: ($event: any) => (_ctx.goRoomFromTr(room)),
                                                      onClickSummary: ($event: any) => (_ctx.clickSummary(room)),
                                                      onShowMembersLinks: _ctx.showMembersLinks,
                                                      onCancelVoted: _ctx.cancelVoted,
                                                      onCancelAppo: _ctx.cancelAppo,
                                                      onChangeActive: _ctx.changeActive,
                                                      onSearchByMember: _ctx.searchByMember,
                                                      onSearchByMag: _ctx.searchByMag,
                                                      onClickFormMember: _ctx.clickFormMember,
                                                      onEditOpenScheduleMemo: _ctx.editOpenScheduleMemo
                                                    }, null, 8, ["room", "canDelete", "showRoomModal", "onGoRoom", "onClickSummary", "onShowMembersLinks", "onCancelVoted", "onCancelAppo", "onChangeActive", "onSearchByMember", "onSearchByMag", "onClickFormMember", "onEditOpenScheduleMemo"]))
                                                  }), 128))
                                                ]))
                                          ]))
                                  ]))
                                : (_ctx.selectedTab == `voted`)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      (!_ctx.currentTabRooms)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createVNode(_component_RoomsLoader)
                                          ]))
                                        : (_ctx.currentTabRooms.length == 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                              _createElementVNode("div", _hoisted_61, [
                                                _hoisted_62,
                                                _createElementVNode("img", {
                                                  src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                                  width: "40",
                                                  height: "40"
                                                }, null, 8, _hoisted_63),
                                                _hoisted_64
                                              ])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                              _createVNode(_component_SuggestedRooms, {
                                                room: _ctx.room,
                                                rooms: _ctx.selectedTab == `voted` ? _ctx.currentTabRooms : null,
                                                showRoomModal: _ctx.showRoomModal,
                                                showMenuModal: _ctx.showMenuModal,
                                                onGoRoom: _ctx.goRoomFromTr,
                                                onFixedAppo: _ctx.fixedAppo,
                                                onClickFormMember: _ctx.clickFormMember
                                              }, null, 8, ["room", "rooms", "showRoomModal", "showMenuModal", "onGoRoom", "onFixedAppo", "onClickFormMember"])
                                            ]))
                                    ]))
                                  : (_ctx.selectedTab == `download`)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                          (_ctx.Util.isPresent(_ctx.downloadableFiles))
                                            ? (_openBlock(), _createElementBlock("section", _hoisted_68, [
                                                _hoisted_69,
                                                _hoisted_70,
                                                _createElementVNode("div", _hoisted_71, [
                                                  _hoisted_72,
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloadableFiles, (file, fileindex) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "w100",
                                                      key: `${fileindex}${file.file_id}${file.original_filename}${file.status}`
                                                    }, [
                                                      _createVNode(_component_DownloadableFileCell, {
                                                        file: file,
                                                        onEditName: _ctx.editName
                                                      }, null, 8, ["file", "onEditName"])
                                                    ]))
                                                  }), 128))
                                                ]),
                                                _hoisted_73
                                              ]))
                                            : _createCommentVNode("", true),
                                          _hoisted_74,
                                          _hoisted_75,
                                          _createVNode(_component_DownloadConditionsContent, { pubRoom: _ctx.room }, null, 8, ["pubRoom"])
                                        ])
                                      ]))
                                    : (_ctx.selectedTab == `parg`)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                          (_ctx.currentTabPargs)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                                (_ctx.currentTabPargs.length == 0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                                      _createElementVNode("div", _hoisted_79, [
                                                        _hoisted_80,
                                                        _createElementVNode("img", {
                                                          src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                                          width: "40",
                                                          height: "40"
                                                        }, null, 8, _hoisted_81)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("table", _hoisted_82, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTabPargs, (parg) => {
                                                        return (_openBlock(), _createBlock(_component_ParentRoomGroupCell, {
                                                          key: `${parg.id}-${parg.updated_at}`,
                                                          class: "hoverLgreyBg pointer",
                                                          parg: parg,
                                                          room: _ctx.room,
                                                          onOpenPargProgress: ($event: any) => (_ctx.openPargProgress(parg)),
                                                          onCancelAppo: _ctx.cancelAppo,
                                                          showRoomModal: _ctx.showRoomModal
                                                        }, null, 8, ["parg", "room", "onOpenPargProgress", "onCancelAppo", "showRoomModal"]))
                                                      }), 128))
                                                    ]))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createVNode(_component_RoomsLoader)
                            ]))
                      ]))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createVNode(_component_RoomsLoader)
                ]))
          ])), [
            [_directive_scroll, _ctx.scroll]
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalRoomMembersLink, {
      members: _ctx.members_with_links,
      room: _ctx.selectedRoom
    }, null, 8, ["members", "room"]),
    _createVNode(_component_PublicLinkModal, { room: _ctx.selectedRoom }, null, 8, ["room"]),
    _createVNode(_component_RoomHistoryDetailModal, { room: _ctx.room }, null, 8, ["room"]),
    _createVNode(_component_ModalCancelAppointment, {
      selectedMessageRoom: _ctx.selectedRoom,
      appo: _ctx.selectedRoom ? _ctx.selectedRoom.current_appointment : null,
      onUpdatedVotedRooms: _ctx.updatedVotedRooms,
      onRescheduledRoom: _ctx.rescheduledRoom,
      onCanceledRoom: _ctx.canceledRoom
    }, null, 8, ["selectedMessageRoom", "appo", "onUpdatedVotedRooms", "onRescheduledRoom", "onCanceledRoom"]),
    _createVNode(_component_CreateFromDraftModal, {
      room: _ctx.selectedRoom,
      modalType: _ctx.modalType,
      closeDraftModal: _ctx.closeDraftModal,
      userFilter: null
    }, null, 8, ["room", "modalType", "closeDraftModal"]),
    _createVNode(_component_CreateFeedbackModal, {
      room: _ctx.selectedRoom,
      member: _ctx.selectedMember,
      onUpdateSelectedRoom: _ctx.updateSelectedRoom
    }, null, 8, ["room", "member", "onUpdateSelectedRoom"]),
    _createVNode(_component_AnsweredFormModal, {
      member: _ctx.selectedMember,
      room: _ctx.room,
      onUpdateMember: _ctx.updateMember
    }, null, 8, ["member", "room", "onUpdateMember"]),
    _createVNode(_component_PrivateMemoModal, {
      room: _ctx.selectedRoom,
      memoType: _ctx.memoType,
      onUpdatedPrivateMemo: _ctx.updatedPrivateMemo,
      onUpdatedOpenScheduleMemo: _ctx.updatedOpenScheduleMemo
    }, null, 8, ["room", "memoType", "onUpdatedPrivateMemo", "onUpdatedOpenScheduleMemo"]),
    _createVNode(_component_InputFileNameModal, {
      file: _ctx.currentFile,
      onRenamed: _ctx.renamed
    }, null, 8, ["file", "onRenamed"]),
    _createVNode(_component_ShareAuthModal, {
      room: _ctx.selectedRoom,
      onHideShareAuthModal: _ctx.hideShareAuthModal
    }, null, 8, ["room", "onHideShareAuthModal"]),
    _createVNode(_component_ChukaiMenuModal, {
      room: _ctx.selectedRoom,
      member: _ctx.selectedMember,
      displayChukaiModalMenuType: _ctx.displayChukaiModalMenuType
    }, null, 8, ["room", "member", "displayChukaiModalMenuType"]),
    _createVNode(_component_RemindModal, {
      selectedUsers: _ctx.selectedUsers,
      selectedRooms: _ctx.selectedRooms,
      parg: _ctx.selectedParg,
      from: `rooms`,
      selectedLpId: _ctx.selectedLpId
    }, null, 8, ["selectedUsers", "selectedRooms", "parg", "selectedLpId"]),
    _createVNode(_component_PargProgressPanel, {
      ref: "pargProgressPanel",
      parg: _ctx.selectedParg,
      onOpenRemindModal: _ctx.openRemindModal
    }, null, 8, ["parg", "onOpenRemindModal"])
  ]))
}